import request from "@/utils/request";

// 登录
export function login(data) {
  return request({
    method: "post",
    path: "auth/login",
    data,
  });
}

// 注册
export function register(data) {
  return request({
    method: "post",
    path: "auth/register",
    data,
  });
}

// 忘记密码
export function forget(data) {
  return request({
    method: "post",
    path: "auth/forget",
    data,
  });
}
